import { useModal } from "mui-modal-provider";
import { TarotCardModal } from "../components/organisms/TarotCardModal";
import { useCallback } from "react";
import { useFreeFortuneContext } from "./useFreeFortuneContext";
import { useRouter } from "next/router";
import { useFreeFortuneKantei } from "../components/v2/Tarot1";

export const useTarotCardModal = () => {
  const { showModal, destroyModal, ...rest } = useModal();
  const { modal, content } = useFreeFortuneContext();
  const { freeFortuneResultContent } = useFreeFortuneKantei({
    contentId: content.id,
    type: "tarot_1",
  });
  const { push } = useRouter();

  const disableScroll = useCallback((e) => {
    e.preventDefault();
  }, []);

  const enableScroll = useCallback(() => {
    window.removeEventListener("touchmove", disableScroll);
    window.removeEventListener("mousewheel", disableScroll);
  }, [disableScroll]);

  const closeTarotCardModal = useCallback(() => {
    destroyModal(modal.current.id);
    modal.current = null;
    enableScroll();
  }, [destroyModal, modal, enableScroll]);

  const showTarotCardModal = useCallback(() => {
    modal.current = showModal(TarotCardModal, {
      onClick: () => {
        push(`/free_fortune/tarot/result/${freeFortuneResultContent.id}`);
        enableScroll();
      },
      onClose: closeTarotCardModal,
    });

    window.addEventListener("touchmove", disableScroll, {
      passive: false,
    });
    window.addEventListener("mousewheel", disableScroll, {
      passive: false,
    });
  }, [
    modal,
    showModal,
    push,
    freeFortuneResultContent,
    enableScroll,
    closeTarotCardModal,
    disableScroll,
  ]);

  return {
    modal: modal.current,
    showModal: showTarotCardModal,
    ...rest,
  };
};
